// eslint-disable-next-line import/no-unresolved -- Vuetify 3 exports-map subpath
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
// eslint-disable-next-line import/no-unresolved -- Vuetify 3 exports-map subpath
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg';

// Matches tmc-local-frontend's light/dark toggle convention, persisted the same way
// (see tmc-local-frontend/src/plugins/my-extensions.js) so this app looks/feels the same.
const lightdark = localStorage.getItem('settings.lightdark') || 'light';

export default createVuetify({
  // Vuetify 3's default input variant is `filled` (grey box). Restore Vuetify 2's
  // underline look app-wide, same as tmc-local-frontend.
  defaults: {
    VTextField: { variant: 'underlined' },
    VSelect: { variant: 'underlined' },
    VAutocomplete: { variant: 'underlined' },
    VCombobox: { variant: 'underlined' },
    VTextarea: { variant: 'underlined' },
    // Vuetify 2 button toggles were a bordered, divided group.
    VBtnToggle: { variant: 'outlined', divided: true },
    // Vuetify 3's table footer uses the generic dataFooter label ("Items per page:");
    // Vuetify 2 tables said "Rows per page:", which Vuetify 3 still ships as the
    // dataTable string.
    VDataTable: { itemsPerPageText: '$vuetify.dataTable.itemsPerPageText' },
    VDataTableServer: { itemsPerPageText: '$vuetify.dataTable.itemsPerPageText' },
    // Vuetify 3's VCardActions makes its buttons text-only; Vuetify 2's were filled, so
    // dialog Save/Delete buttons lost their color. Buttons that set variant="text"
    // (Cancel, Close) keep it.
    VCardActions: { VBtn: { variant: 'elevated' } },
  },
  theme: {
    defaultTheme: lightdark === 'dark' ? 'dark' : 'light',
    themes: {
      // Same primary blue used by tmc-local-frontend's app bar (App.vue "primary" color).
      // Vuetify 2's default accent, which Vuetify 3 dropped.
      light: {
        colors: {
          primary: '#1976D2',
          accent: '#82B1FF',
        },
      },
      dark: {
        dark: true,
        colors: {
          accent: '#e6de55',
        },
      },
    },
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi },
  },
});
